import React, { useState, useEffect } from 'react'
import LoadingSpinner from "../../components/LoadingSpinner.js";
import { DateTimeSelector, OffsetSelector, DueDate } from '../components';
import { Pagination } from '@CommonComponents/buttons';
import { PAGINATION_RATE } from '../constants';
import { useStateValue } from '@State';
import { actions } from '../reducer';

export function ActivityViewer({ allActivities, state, timeZoneFormatter }) {
  const components = {
    'loading': {
      Component: LoadingSpinner,
      props: {}
    },
    'loaded': {
      Component: ActivityTable,
      props: { allActivities, timeZoneFormatter }
    }
  }

  const { Component, props } = state ? components[state] : components['loading']
  return <div className="card-myed">
    <h3>Activities</h3>
    <Component {...props}></Component>
  </div>
}

function ActivityTable({ allActivities, timeZoneFormatter }) {
  const [{ strategy, selectedActivities }, dispatch] = useStateValue()
  const inputType = strategy.activitiesInputType
  const disabled = strategy.disableInputs
  const [isAllSelectedChecked, setIsAllSelectedChecked] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)

  const allActivitiesList = Object.values(allActivities)
  const startIdx = (currentPage - 1) * PAGINATION_RATE
  const paginatedActivities = allActivitiesList.slice(startIdx, startIdx + PAGINATION_RATE)

  // Sync local "select all" state when selections change externally (e.g., after Apply)
  useEffect(() => {
    const allSelected = selectedActivities.size === allActivitiesList.length && allActivitiesList.length > 0
    setIsAllSelectedChecked(allSelected)
  }, [selectedActivities.size, allActivitiesList.length])

  function handleSelectAllCheckbox() {
    if (isAllSelectedChecked) {
      dispatch({ type: actions.UNSELECT_ALL_ACTIVITIES })
    } else {
      dispatch({ type: actions.SELECT_ALL_ACTIVITIES, guids: Object.keys(allActivities) })
    }
    setIsAllSelectedChecked(prev => !prev)
  }

  function handleToggleActivity(guid) {
    if (!strategy.activitiesMultiSelect) {
      dispatch({ type: actions.UNSELECT_ALL_ACTIVITIES })
    }
    dispatch({ type: actions.TOGGLE_ACTIVITY, guid })
  }

  return <div >
    {inputType && inputType === 'date' &&
      <div className='card-myed'>
        <DateTimeSelector
          disabled={disabled}
          onChange={(date) => dispatch({ type: actions.UPDATE_DATE, date })}
        ></DateTimeSelector>
      </div>
    }
    {inputType && inputType === 'offset' &&
      <div className='card-myed'>
        <OffsetSelector
          disabled={disabled}
          onChange={(key, value) => dispatch({ type: actions.UPDATE_OFFSET, key, value })}
        ></OffsetSelector>
      </div>
    }

    <div className='card-myed'>
      <table className='table table-striped table-hover'>
        <thead>
          <tr
            key={'activities'}
            onClick={() => { if (!disabled && strategy.activitiesMultiSelect) handleSelectAllCheckbox() }}
          >
            <th scope="col" style={{ width: '25px' }}>
              {strategy.activitiesMultiSelect &&
                <input disabled={disabled} type='checkbox' checked={isAllSelectedChecked} readOnly></input>
              }
            </th>
            <th scope="col" style={{ width: '250px' }}>Title</th>
            <th scope="col" style={{ width: '250px' }}>Group</th>
            <th scope="col">Current Due Date</th>
          </tr>
        </thead>
        <tbody>
          {paginatedActivities.map(act => {
            return <tr
              key={act.guid}
              onClick={() => { if (!disabled) handleToggleActivity(act.guid) }}
            >
              <td >
                <input
                  disabled={disabled}
                  name="activitiesSelect"
                  readOnly
                  type={strategy.activitiesMultiSelect ? 'checkbox' : 'radio'}
                  value={act.guid}
                  checked={selectedActivities.has(act.guid)}>
                </input>
              </td>
              <td className='text-left'>{act.title}</td>
              <td className='text-left'>{act.parent_title}</td>
              <td ><DueDate date={timeZoneFormatter(act.current_due_date)}></DueDate></td>
            </tr>
          })}
        </tbody>
      </table>
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        rate={PAGINATION_RATE}
        total={allActivitiesList.length}
      />
    </div>
  </div >
}
